export const schoolTimings = {
  ramadan: [
    { class: "Play Group (PG)", days: "Monday - Friday", open: "8:00 AM", close: "11:00 AM", note: "Ramadan" },
    { class: "Nursery", days: "Monday - Friday", open: "8:00 AM", close: "11:30 AM", note: "Ramadan" },
    { class: "Prep - Class 10", days: "Monday - Friday", open: "8:00 AM", close: "12:30 PM", note: "Ramadan" }
  ],
  regular: [
    { class: "Play Group (PG)", days: "Monday - Friday", open: "8:00 AM", close: "11:30 AM", note: null },
    { class: "Nursery", days: "Monday - Friday", open: "8:00 AM", close: "11:30 AM", note: null },
    { class: "Prep - Class 10", days: "Monday - Friday", open: "8:00 AM", close: "1:30 PM", note: null }
  ]
};

export const academyTimings = {
  ramadan: [
    { program: "All Subjects & Classes", days: "Monday - Saturday", open: "2:00 PM", close: "5:30 PM" }
  ],
  regular: [
    { program: "All Subjects & Classes", days: "Monday - Saturday", open: "3:00 PM", close: "7:00 PM" }
  ]
};